<template>
  <div style="padding-top: 0.7rem;">
    <div
      style="width: 12rem; margin: .24rem auto;padding: .24rem;background: #FFF;border-radius: 0.08rem;display: flex;flex-direction: column;row-gap: .32rem;">
      <div class="" style="display: flex;column-gap: .4rem;" v-for="item in classifyList" :key="item.id">
        <div class="" style="color: #90969C;font-size: .14rem; font-weight: 700;flex-basis: 30px;">
          <span>{{ item.title }}</span>
        </div>
        <div style="flex: 1;display: flex; column-gap: .24rem;row-gap: .24rem;align-items: center;flex-wrap: wrap;">
          <div @click="allBtn(item)"
            :style="['font-size: .14rem;padding: .04rem .09rem;border-radius: 1rem;cursor: pointer', item.openId == '全部' ? 'color: #C01A26; background: #f2d1d4;' : 'color: #333333;background:#FFF']">
            <span>全部</span>
          </div>
          <div @click="clickItem(item, item_.id)"
            :style="['color: #333333; font-size: .14rem;cursor: pointer;padding: .04rem .09rem;border-radius: 1rem', item.openId.split(',').includes(String(item_.id)) ? 'color: #C01A26; background: #f2d1d4;' : 'color: #333333;background:#FFF']"
            v-for="item_ in item.list" :key="item_.id">
            <span>{{ item_.title
            }}</span>
          </div>
        </div>
      </div>
      <!--  -->
      <el-skeleton :rows="6" v-if="classifyLoading" />
    </div>
    <!--  -->
    <div class="" style="width: 12rem; margin: .24rem auto;min-height: 2rem;">
      <div v-if="loading"
        style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 0.24rem;padding-bottom: .24rem;">
        <el-skeleton v-for="item in 12" :key="item" :loading="loading" :throttle="{ trailing: 1000 }" :animated="true">
          <template #template>
            <el-skeleton-item variant="image" style="height: 1.58rem;" />
            <div style="padding: 14px">
              <el-skeleton-item variant="h3" style="width: 30%" />
              <el-skeleton-item variant="text" style="margin-right: 16px" />
            </div>
          </template>
        </el-skeleton>
      </div>
      <div v-if="!loading && listData" style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 0.24rem;">
        <moduleSEProvideMaterial v-for="item in listData" :key="item.id" :item="item" class="SL_offerMaterialListdiv cur">
        </moduleSEProvideMaterial>
      </div>
      <div v-if="!loading && !listData.length">
        <el-empty description="暂无数据" />
      </div>
      <div v-if="listData.length"
        style="padding-bottom: 20px;padding-top: .4rem; display: flex;justify-content: center;align-items: center;width: 100%;">
        <el-pagination :total="queryParams.total" background class="cccccccc" :current-page="queryParams.pageNum"
          @current-change="paginationChange" :page-size="queryParams.pageSize" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import moduleSEProvideMaterial from "../../components/moduleSEProvideMaterial.vue";
const classifyList = ref([]);
const classifyLoading = ref(true);
const urlData = new URLSearchParams(location.search);
const getClassify = () => {
  classifyLoading.value = true;
  Axios(
    "get",
    "/system/courseWeb/classifys",
    {},
    false,
    (res) => {
      if (res.data.code == 200) {
        res.data.data.length && (res.data.data.push({
          id: 'x',
          title: "类型",
          list: [{
            id: 'x-1',
            title: "在线课程",
          }, {
            id: 'x-2',
            title: "线下实战课",
          }]
        }));
        classifyList.value = res.data.data.map(item => {
          return {
            ...item,
            openId: item.id == 'x' ? urlData.get('type') || "全部" : "全部"
          }
        });
        classifyLoading.value = false;

      }
    }, () => {
      classifyList.value = [];
      classifyLoading.value = false;
    }
  );
}
getClassify()
const clickItem = (item, id) => {
  if (item.openId && item.id != 'x') {
    let a = item.openId.split(',');
    a.includes(String(id)) ? a.splice(a.indexOf(String(id)), 1) && (item.openId = a.join(',')) : item.openId = item.openId == '全部' ? String(id) : a.join(',') + ',' + String(id)
    !item.openId && (item.openId = '全部');
  } else {
    item.openId = String(id)
  }
  setData()
}
const setData = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  queryParams.value.type = classifyList.value.filter(item => item.id == 'x')[0].openId.split('-')[1];
  if (queryParams.value.type == '全部' || !queryParams.value.type) {
    queryParams.value.type = '';
  }
  queryParams.value.classifyId = classifyList.value.filter(item => item.id != 'x' && item.openId != '全部').map(item_ => item_.openId).join(',');
  queryParams.value.pageNum = 1;
  getList()
}
const allBtn = (item) => {
  item.openId = '全部';
  setData()
}
const listData = ref([]);
const loading = ref(false);
const queryParams = ref({
  pageNum: 1,
  pageSize: 12,
  total: 0,
  type: urlData.get('type') && urlData.get('type').split('-')[1] || "",
  classifyId: "",
})
const getList = () => {
  loading.value = true;
  Axios(
    "get",
    "/system/courseWeb/list",
    Object.assign({
      pageNum: queryParams.value.pageNum,
      pageSize: queryParams.value.pageSize,
      classifyId: queryParams.value.classifyId
    }, queryParams.value.type ? {
      type: Number(queryParams.value.type),
    } : {}),
    false,
    (res) => {
      listData.value = res.data.rows;
      queryParams.value.total = res.data.total;
      setTimeout(() => {
        loading.value = false;
      }, 1000);
    }, () => {
      listData.value = [];
      queryParams.value.total = 0;
      setTimeout(() => {
        loading.value = false;
      }, 1000);
    })
}
getList()
const paginationChange = (num) => {
  queryParams.value.pageNum = num;
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  getList()
}
// const goDetailPage = function (id) {
//   router.push({
//     path: "/ShadowTrainDetailPage",
//     query: { id: id },
//   });
// };
</script>

<style>
.cccccccc.el-pagination.is-background .btn-next.is-active,
.cccccccc.el-pagination.is-background .btn-prev.is-active,
.cccccccc.el-pagination.is-background .el-pager li.is-active {
  background-color: #C01A26 !important;
}

/* .el-pager li.is-active, */
.cccccccc .el-pager li:hover {
  color: #C01A26 !important;
}

.cccccccc .el-pager li.is-active:hover {
  color: #FFF !important;
}
</style>
